export function enumToOptions(enumObj) {
    return Object.entries(enumObj).map(([key, value]) => ({ label: value, value: key }));
}
